<template>
    <div class="app-dark-bg" data-app>
        <!-- NAVBAR -->
        <v-app-bar app flat elevate-on-scroll class="glass-nav">
            <v-toolbar-title class="font-weight-black pointer" @click.prevent="goToHome">
                <span class="brand">DIRECIONA</span><span class="brand-accent"> TECH</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text class="nav-link" @click="scrollTo('#features')">Recursos</v-btn>
            <v-btn text class="nav-link" @click="scrollTo('#how')">Como funciona</v-btn>
            <v-btn text class="nav-link" @click="scrollTo('#faq')">FAQ</v-btn>
            <v-divider vertical class="mx-4" inset></v-divider>
            <v-btn color="blue" class="text-none font-weight-bold" depressed @click="$router.push('/login')">
                Entrar
            </v-btn>
        </v-app-bar>
        <main class="main-content">
            <router-view />
        </main>
        <!-- FOOTER -->
        <footer class="footer">
            <v-row class="text-center">
                <v-col cols="12" md="12" class="text-center">
                    <div class="footer-brand">
                        <span class="brand">DIRECIONA</span><span class="brand-accent"> TECH</span>
                    </div>
                    <div class="footer-copy">
                        © {{ new Date().getFullYear() }} DIRECIONA TECH — Todos os direitos reservados.
                    </div>
                    <v-btn v-for="(s, i) in socials" :key="i" icon :href="s.href" target="_blank" class="mx-1">
                        <v-icon class="gradient-text">{{ s.icon }}</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            items: [
                { title: 'Chat', icon: 'mdi-chat', route: '/chat' },
                { title: 'Imagens', icon: 'mdi-image', route: '/image' },
                // { title: 'Configurações', icon: 'mdi-cog', route: '/settings' },
            ],
            socials: [
                { icon: 'mdi-linkedin', href: 'https://www.linkedin.com/' },
                { icon: 'mdi-twitter', href: 'https://x.com/' },
                { icon: 'mdi-gmail', href: 'https://gmail.com/' },
            ],
        };
    },
    methods: {
        goToHome() {
            if (this.$route.path === '/') {
                this.scrollToTop();
                return;
            }
            this.$router.push('/');
        },
        scrollTo(selector) {
            const el = document.querySelector(selector)
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        },
        scrollToTop() {
            const main = document.querySelector('.main-content');
            if (main) {
                main.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }
};
</script>

<style scoped>
.app-dark-bg {
    min-height: 100vh;
    width: 100vw;
    color: #2c2c2c;
    background: #181818;
    display: flex;
    flex-direction: column;
}

.glass-nav {
    backdrop-filter: blur(10px);
    background: rgba(24, 24, 24, 0.7) !important;
    color: #ffffff !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-link {
    color: #ffffff !important;
    font-weight: 400;
    text-transform: none;
}

.icon {
    color: #ff9800;
}

.main-content {
    flex: 1;
    background: #181818;
    color: #000000;
    overflow-x: hidden;
    position: relative;
    margin-left: 0;
    max-height: 85vh;
}

.title {
    cursor: pointer;
    font-weight: 900;
    font-size: 1.2rem;
    letter-spacing: 1px;
    color: #da7019;
}
.footer {
    background: #181818;
    color: #fff;
    text-align: center;
    margin: 0 auto;
    padding: 3px 0;
    width: 100%;
    height: 20px;
    flex-shrink: 0;
}
.footer-link {
    color: #ff9800 !important;
    text-decoration: none;
    font-weight: 600;
}
.text-center {
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin: 0 auto;
}
.gradient-text {
  background: linear-gradient(90deg, #60a5fa, #34d399, #a78bfa);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.pointer {
    cursor: pointer;
}
</style>
